import RestResourceService from "@/services/RestResourcesService";
import errorParser from '@/utils/error-parser'
import AuthService from "@/services/AuthService";
import router from "@/router";


function initialState() {
    return {
        currentTenant: '',
        tenants: [],
        allTenants: [],
        loading: true,
        gettingProfile: false,
        assignedRoles: [],
        currentRole: '',
        currentEmail: '',
        showRawTab: false,
        permissions: [],
        permissionsWithFields: []
    }
}

export default {
    state: initialState(),
    getters: {
        GETTING_PROFILE: state => {
            return state.gettingProfile;
        },
        CURRENT_TENANT: state => {
            return state.currentTenant
        },
        PERMISSIONS_WITH_FIELDS: state => {
            return state.permissionsWithFields
        },
        PERMISSIONS: state => {
            return state.permissions
        },
        TENANTS: state => {
            return state.tenants
        },
        CURRENT_EMAIL: state => {
            return state.currentEmail
        },
        SHOW_RAW_TAB: state => {
            return state.showRawTab;
        },
        CURRENT_ROLE: state => {
            return state.currentRole
        },
        ALLTENANTS: state => {
            return state.allTenants
        },
        ASSIGNED_ROLES: state => {
            return state.assignedRoles;
        }
    },
    mutations: {
        SET_GETTING_PROFILE(state, payload) {
            state.gettingProfile = payload;
        },
        SET_CURRENT_TENANT(state, payload) {
            state.currentTenant = payload;
        },
        SET_CURRENT_EMAIL(state, payload) {
            state.currentEmail = payload;
        },
        SET_PERMISSIONS(state, payload) {
            state.permissions = payload
        },
        SET_PERMISSIONS_WITH_FIELDS(state, payload) {
            state.permissionsWithFields = payload
        },
        SET_SHOW_RAW_TAB(state, payload) {
            state.showRawTab = payload;
        },
        SET_CURRENT_ROLE(state, payload) {
            state.currentRole = payload;
        },
        SET_ASSIGNED_ROLES(state, payload) {
            state.assignedRoles = payload
        },
        SET_TENANTS(state, payload) {
            state.allTenants = [...payload];
            for (let i = 0; i < payload.length; i++) {
                if (payload[i]['code'] === state.currentTenant.code) {
                    payload.splice(i, 1);
                }
            }
            state.tenants = payload
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        }
    },
    actions: {
        GET_PROFILE: async ({commit, dispatch}, tenant) => {
            commit('SET_LOADING', true);
            let url = 'admin/profile'
            if (tenant) {
                url += `?tenant=${tenant}`
            }

            return RestResourceService.getResources(url)
                .then((response) => {
                    dispatch('SET_PROFILE', response);
                    return response.data;
                })
                .catch((error) => {
                    commit('SET_LOADING', false);

                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: true,
                        redirectToLoginPage: true,
                        showNotification: true
                    });
                    throw new Error(error);
                })
        },
        UPDATE_PROFILE: async ({commit, dispatch}, payload) => {
            commit('SET_LOADING', true);

            return RestResourceService.updateResources('admin/profile/tenant', payload.currentTenant)
                .then((response) => {
                    dispatch('SET_PROFILE', response);


                })
                .catch((error) => {
                    commit('SET_LOADING', false);

                    errorParser.parse({
                        error: error,
                        redirectTo404Page: false,
                        redirectTo500Page: false,
                        clearAuthData: true,
                        redirectToLoginPage: true,
                        showNotification: true,
                    });
                    throw new Error(error);
                })
        },
        CHANGE_CURRENT_TENANT: async ({commit, dispatch}, payload) => {
            await dispatch('UPDATE_PROFILE', payload);
        },
        CHANGE_CURRENT_ROLE: ({commit, dispatch}, payload) => {
            commit('SET_LOADING', true);

            return RestResourceService.updateResources('admin/profile/role', {roleCode: payload}).then(response => {
                dispatch('SET_PROFILE', response);

            }).catch((error) => {
                commit('SET_LOADING', false);

                errorParser.parse({
                    error: error,
                    redirectTo404Page: false,
                    redirectTo500Page: false,
                    clearAuthData: true,
                    redirectToLoginPage: true,
                    showNotification: true,
                });
                throw new Error(error);
            })
        },
        SET_PROFILE: async ({commit, dispatch}, response) => {
            commit("SET_CURRENT_ROLE", response.data.currentRoleCode);
            //AuthService.saveProfileDetails(response.data);
            if(response.data.currentRoleCode) {
                commit('SET_PERMISSIONS', AuthService.convertPermissions(response.data.permissionsV3.roles[response.data.currentRoleCode] ))
                commit('SET_PERMISSIONS_WITH_FIELDS', response.data.permissionsV3.roles[response.data.currentRoleCode])
            }
            else {
                commit('SET_PERMISSIONS', AuthService.convertPermissions(response.data.permissionsV3.merged ))
                commit('SET_PERMISSIONS_WITH_FIELDS', response.data.permissionsV3.merged)
            }
            commit('SET_CURRENT_TENANT', response.data.currentTenant);
            commit('SET_CURRENT_EMAIL', response.data.userName);
            commit('SET_ASSIGNED_ROLES', Object.keys(response.data.permissionsV3.roles));

            commit('SET_TENANTS', response.data.tenants);
            commit('SET_LOADING', false);
            if (response.data.visibility.find(x => x.code === 'raw')) {
                commit("SET_SHOW_RAW_TAB", true);
            } else {
                commit("SET_SHOW_RAW_TAB", false);

            }
        },

    }
}
